/* Actually relaunch — tiny runtime helpers. No dependencies. */
(function () {
  // 1. Respect slow connections / data saver: don't autoplay background video, keep the poster.
  try {
    var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    var slow = c && (c.saveData || /(^|[^0-9])(slow-2g|2g|3g)$/.test(c.effectiveType || ''));
    if (slow) {
      document.querySelectorAll('video[autoplay]').forEach(function (v) {
        v.removeAttribute('autoplay'); v.pause && v.pause();
      });
      document.documentElement.classList.add('a-slow-connection');
    }
  } catch (e) {}

  // 2. Make sure lazy videos never fetch until the user presses play.
  document.querySelectorAll('.a-video video').forEach(function (v) {
    if (!v.getAttribute('preload')) v.setAttribute('preload', 'none');
  });
})();

/* ---------- 2026-09-08: timeline, graveyard, scoreboard, quiz ---------- */
(function () {
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var hasIO = 'IntersectionObserver' in window;

  /* 30-day timeline: nearest checkpoint to the focus line is active; sticky photo + day badge follow; rail fills. */
  document.querySelectorAll('[data-a-timeline]').forEach(function (tl) {
    var cps = [].slice.call(tl.querySelectorAll('[data-a-tl-cp]'));
    if (!cps.length) return;
    var imgs = [].slice.call(tl.querySelectorAll('[data-a-tl-img]'));
    var day = tl.querySelector('[data-a-tl-day]');
    var fill = tl.querySelector('[data-a-tl-fill]');
    var list = tl.querySelector('.a-tl__list');
    var active = -1;
    function setActive(i) {
      if (i === active) return;
      active = i;
      var idx = cps[i].getAttribute('data-index');
      cps.forEach(function (c, k) { c.classList.toggle('is-active', k === i); });
      imgs.forEach(function (im) { im.classList.toggle('is-active', im.getAttribute('data-a-tl-img') === idx); });
      if (day) day.textContent = cps[i].getAttribute('data-day');
    }
    setActive(0);
    if (hasIO) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-seen'); io.unobserve(e.target); } });
      }, { threshold: 0.25 });
      cps.forEach(function (c) { io.observe(c); });
    } else { cps.forEach(function (c) { c.classList.add('is-seen'); }); }
    var queued = false;
    function update() {
      queued = false;
      var focus = window.innerHeight * 0.42, best = 0, bestD = Infinity;
      cps.forEach(function (c, k) {
        var r = c.getBoundingClientRect();
        var d = Math.abs(r.top + Math.min(r.height, 160) / 2 - focus);
        if (d < bestD) { bestD = d; best = k; }
      });
      setActive(best);
      if (fill && list) {
        var first = cps[0].getBoundingClientRect(), last = cps[cps.length - 1].getBoundingClientRect();
        var lr = list.getBoundingClientRect();
        var span = Math.max(1, last.top - first.top);
        var p = Math.max(0, Math.min(1, (focus - first.top) / span));
        fill.style.height = Math.max(0, (first.top - lr.top) - 10 + p * span + 10) + 'px';
      }
    }
    function onScroll() { if (!queued) { queued = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  });

  /* Graveyard: strike-through on first view (staggered), tap-to-reveal on touch, Esc closes. */
  document.querySelectorAll('[data-a-grave]').forEach(function (g) {
    var cards = [].slice.call(g.querySelectorAll('[data-a-grave-card]'));
    cards.forEach(function (c, i) { c.style.setProperty('--a-i', i % 6); });
    if (hasIO) {
      var gio = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-seen'); gio.unobserve(e.target); } });
      }, { threshold: 0.35 });
      cards.forEach(function (c) { gio.observe(c); });
    } else { cards.forEach(function (c) { c.classList.add('is-seen'); }); }
    function closeAll() {
      cards.forEach(function (c) {
        c.classList.remove('is-open');
        var b = c.querySelector('[data-a-grave-toggle]'); if (b) b.setAttribute('aria-expanded', 'false');
      });
    }
    g.addEventListener('click', function (ev) {
      var t = ev.target.closest('[data-a-grave-toggle]'); if (!t) return;
      var card = t.closest('[data-a-grave-card]');
      var open = !card.classList.contains('is-open');
      closeAll();
      if (open) { card.classList.add('is-open'); t.setAttribute('aria-expanded', 'true'); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  });

  /* Scoreboard: count up + bar fill when it scrolls into view. */
  var boards = [].slice.call(document.querySelectorAll('[data-a-score]'));
  function runBoard(el) {
    if (el.classList.contains('is-seen')) return;
    el.classList.add('is-seen');
    if (reduce || document.hidden) return; /* server-rendered numbers already show the final values */
    el.querySelectorAll('[data-a-count]').forEach(function (n) {
      var target = parseInt(n.getAttribute('data-a-count'), 10);
      if (!isFinite(target) || target <= 0) return;
      var start = null, dur = 900;
      n.textContent = '0';
      function step(t) {
        if (start === null) start = t;
        var p = Math.min(1, (t - start) / dur), e = 1 - Math.pow(1 - p, 3);
        n.textContent = Math.round(e * target);
        if (p < 1) requestAnimationFrame(step); else n.textContent = target;
      }
      requestAnimationFrame(step);
    });
  }
  if (hasIO) {
    var sio = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { runBoard(e.target); sio.unobserve(e.target); } });
    }, { threshold: 0.5 });
    boards.forEach(function (b) { sio.observe(b); });
  } else { boards.forEach(runBoard); }

  /* Pick your problem: tabs → result panel, arrow keys move between options. */
  document.querySelectorAll('[data-a-quiz]').forEach(function (q) {
    var opts = [].slice.call(q.querySelectorAll('[data-a-quiz-opt]'));
    var panels = [].slice.call(q.querySelectorAll('[data-a-quiz-panel]'));
    var prompt = q.querySelector('[data-a-quiz-prompt]');
    function pick(i) {
      opts.forEach(function (o, k) { o.setAttribute('aria-selected', k === i ? 'true' : 'false'); o.tabIndex = k === i ? 0 : -1; });
      panels.forEach(function (p, k) {
        var show = k === i;
        if (show && !p.hidden) { p.style.animation = 'none'; void p.offsetWidth; p.style.animation = ''; }
        p.hidden = !show;
      });
      if (prompt) prompt.hidden = i >= 0;
    }
    opts.forEach(function (o, i) {
      o.tabIndex = i === 0 ? 0 : -1;
      o.addEventListener('click', function () { pick(i); });
      o.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : (e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 0);
        if (!d) return;
        e.preventDefault();
        var n = (i + d + opts.length) % opts.length;
        opts[n].focus(); pick(n);
      });
    });
  });
})();
